import { TypeOf, z } from 'zod';

export const loginSchema = z.object({
	mobileNumber: z.string().min(6).default(''),
	confirmationCode: z.string().min(6).default(''),
	pinCode: z.string().min(4).default(''),
});
export type LoginSchema = TypeOf<typeof loginSchema>;
